module.exports = __webpack_public_path__ + "../static/img/default_device_os.01df6e32.png";